import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-terms-conditions',
  templateUrl: './new-terms-conditions.component.html',
  styleUrls: ['./new-terms-conditions.component.scss']
})
export class NewTermsConditionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
